import { components } from 'react-select';
import { Icon } from '@chakra-ui/react';
import { Close } from '@/assets/icons/form/Close';

export const MultiSelectRemoveIcon = (props: any) => {
  return (
    <components.MultiValueRemove {...props}>
      <Icon as={Close} w="19px" h="19px" mt="2px" />
    </components.MultiValueRemove>
  );
};
